import { render } from "./Gift-card-page.vue?vue&type=template&id=2ccaae77"
import script from "./Gift-card-page.vue?vue&type=script&lang=js"
export * from "./Gift-card-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__